export default __webpack_public_path__ + "static/media/13-2-chair-free-download-png 2.dacf58e3.png";